var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinanceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFB000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6098_9676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0827 13.2802L16.894 15.0908L11.992 19.9928L7.09067 15.0915L8.902 13.2802L11.9927 16.3868L15.0827 13.2802ZM18.174 10.1895L20 12.0002L18.19 13.8108L16.3787 12.0002L18.174 10.1895ZM11.9927 10.1895L13.8033 11.9842L11.992 13.7955L10.1813 12.0002L11.992 10.1902L11.9927 10.1895ZM5.81067 10.1895L7.60667 12.0002L5.812 13.7948L4 12.0002L5.81067 10.1895ZM11.9933 4.00684L16.8947 8.8935L15.0833 10.7035L11.9927 7.61284L8.90267 10.7195L7.09133 8.90884L11.9927 4.0075L11.9933 4.00684Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6098_9676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceLogo);
export default __webpack_public_path__ + "static/media/binance-logo.713260ba88f5958bfea02b7ebffd856e.svg";
export { ForwardRef as ReactComponent };